// extracted by mini-css-extract-plugin
export default {"nicknameInput":"Nickname_nicknameInput__J0MqT"};